export default __webpack_public_path__ + "assets/rate.e36cd0b6.svg";